import Grid from "@mui/material/Grid";
import React, { useState, useEffect, useContext } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import QaiScorecardChallengeQuestionsViewModel, { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";
import QaiChallengePage from "./QaiChallengePage";
import QaiChallengeTable from "./QaiChallengeTable";
import QaiChallengeFilterBar from "./QaiChallengeFilterBar";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import ChallengeQuestionContainer from "../AgentView/ChallengeQuestionContainer";
import UserType from "../../Utilities/UserType";

interface IQaiChallengeContainerProps {
    view: string
}

export default function QaiChallengeContainer({ view }: IQaiChallengeContainerProps) {
    const { post } = useContext(APIContext);
    const [challengedQuestionsViewModel, setChallengedQuestionsViewModel] = useState<QaiScorecardChallengeQuestionsViewModel>(new QaiScorecardChallengeQuestionsViewModel);
    const [filters, setFilters] = useState<QaiChallengeFilterViewModel>(new QaiChallengeFilterViewModel(view));
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState<QaiScorecardChallengeQuestionViewModel | null>(null);
    const [openChallengeDialog, setOpenChallengeDialog] = useState(false);

    useEffect(() => {
        getChallengedQuestions();
    }, [])

    useEffect(() => {
        getChallengedQuestions();
    }, [filters.pageNumber])

    const getChallengedQuestions = () => {
        post('QaiScorecardChallenge', 'GetChallengedQuestions', filters, (data) => setChallengedQuestionsViewModel(data));
    }

    const changePage = (newPage: number) => {
        setFilters({
            ...filters,
            pageNumber: newPage
        })
    }

    const handleChallengeOpen = (questionId: number, aiTemplateVersion: number) => {
        const newSelectedQuestion = challengedQuestionsViewModel.questions
            .find(x => x.questionId === questionId && x.aiTemplateVersion === aiTemplateVersion);
        if (newSelectedQuestion) {
            setSelectedQuestion(newSelectedQuestion);
            setOpenDialog(true);
        }
    }

    const handleChallengeClose = () => {
        setSelectedQuestion(null);
        setOpenDialog(false);
    }

    return (
        <Grid container overflow="hidden" maxHeight="90vh" border="solid 1px gray" padding={1}>
            <Grid size={12}>
                <QaiChallengeFilterBar filters={filters} setFilters={setFilters} getChallenges={getChallengedQuestions} setOpenChallengeDialog={setOpenChallengeDialog} />
            </Grid>
            <QaiChallengeTable challengedQuestionsViewModel={challengedQuestionsViewModel} handleChallengeOpen={handleChallengeOpen} pageNumber={filters.pageNumber} changePage={changePage} />
            <Dialog open={openChallengeDialog} maxWidth="lg" fullWidth>
                <DialogTitle>Challenge question</DialogTitle>
                <ChallengeQuestionContainer view={UserType.TeamLeader} setOpenChallengeDialog={setOpenChallengeDialog} />
            </Dialog>
            {
                selectedQuestion &&
                <QaiChallengePage
                    openDialog={openDialog}
                    handleChallengeClose={handleChallengeClose}
                    questionViewModel={selectedQuestion}
                    filters={filters}
                    view={view}
                    getChallengedQuestions={getChallengedQuestions}
                />
            }
        </Grid>
    )
}